import Certificate from './Certificate'
import RequestDetail from './RequestDetail'
import SearchSlips from './SearchSlips'

export default {
  Certificate,
  SearchSlips,
  RequestDetail
}



// WEBPACK FOOTER //
// ./src/components/Refund/index.js